module.exports = __webpack_public_path__ + "img/collage_img_03.5a48a3d2.jpg";